const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹'

export const toFaDigits = (n: number | string) =>
    String(n).replace(/\d/g, d => FA_DIGITS[+d])
